import type { Entity } from "@kkindex/shared";

export function moveRelative<T extends { id: string }>(
  items: T[],
  sourceId: string,
  targetId: string,
  after: boolean,
): T[] {
  const source = items.find((item) => item.id === sourceId);
  if (
    !source ||
    sourceId === targetId ||
    !items.some((item) => item.id === targetId)
  )
    return items;
  const next = items.filter((item) => item.id !== sourceId);
  next.splice(
    next.findIndex((item) => item.id === targetId) + (after ? 1 : 0),
    0,
    source,
  );
  return next;
}

// Narrow screens collapse columns for display only; saved positions remain intact.
export function taskColumns(parents: Entity[], count: number): Entity[][] {
  const columns: Entity[][] = Array.from({ length: count }, () => []);
  parents.forEach((parent, index) => {
    const column = Math.min(parent.cardColumn ?? index % count, count - 1);
    columns[column].push(parent);
  });
  return columns;
}
